import { CategoryData } from '../../../../types/types';

export const famille: CategoryData = {
    // Parents



    'Tata (Père)': {
        translation: 'Père',
        translationEn: 'Father',
        illustration: '👨',
        audio: 'Li-tata',
        explanation: 'Terme pour désigner le père dans la famille',
        explanationEn: 'Term used to refer to the father in the family',
        example: 'Tata azali kosala. (Le père travaille.)',
        exampleEn: 'Tata azali kosala. (The father is working.)'
    },
    'Mama (Mère)': {
        translation: 'Mère',
        translationEn: 'Mother',
        illustration: '👩',
        audio: 'Li-mama',
        explanation: 'Terme pour désigner la mère dans la famille',
        explanationEn: 'Term used to refer to the mother in the family',
        example: 'Mama azali kosala na ndako. (La mère fait le ménage.)',
        exampleEn: 'Mama azali kosala na ndako. (The mother is doing housework.)'
    },
    'Tata na mama (Parents)': {
        translation: 'Parents',
        translationEn: 'Parents',
        illustration: '👨‍👩',
        audio: 'Li-tata_na_mama',
        explanation: 'Expression utilisée pour parler du père et de la mère ensemble',
        explanationEn: 'Expression used to refer to the father and mother together',
        example: 'Tata na mama balingi bana na bango. (Les parents aiment leurs enfants.)',
        exampleEn: 'Tata na mama balingi bana na bango. (The parents love their children.)'
    },

    // Fratrie et termes affectueux
    'Yaya / Kulutu (Grand-frère / Grande-sœur)': {
        translation: 'Grand-frère / Grande-sœur',
        translationEn: 'Older brother / Older sister',
        illustration: '👦👧',
        audio: 'Li-yaya',
        explanation: 'Terme affectueux pour désigner un grand frère ou une grande sœur. Le mot "Yaya" devient "Ya" quand il est suivi du prénom (ex: Ya Bolingo, Ya Masumu, Ya Kuedy)',
        explanationEn: 'Affectionate term for an older brother or older sister. The word "Yaya" becomes "Ya" when followed by a first name (e.g. Ya Bolingo, Ya Masumu, Ya Kuedy)',
        example: 'Yaya azali koteya ngai. (Mon grand frère/ma grande sœur m\'enseigne.)',
        exampleEn: 'Yaya azali koteya ngai. (My older brother/sister is teaching me.)'
    },
    'Leki (Petit-frère / Petite-sœur)': {
        translation: 'Petit-frère / Petite-sœur',
        translationEn: 'Younger brother / Younger sister',
        illustration: '👦👧',
        audio: 'Li-leki',
        explanation: 'Terme pour désigner un petit frère ou une petite sœur',
        explanationEn: 'Term used for a younger brother or younger sister',
        example: 'Leki azali kosala devoirs. (Mon petit frère/ma petite sœur fait ses devoirs.)',
        exampleEn: 'Leki azali kosala devoirs. (My younger brother/sister is doing homework.)'
    },

    // Frères, sœurs et enfants
    'Ndeko mobali (Frère / Cousin)': {
        translation: 'Frère / Cousin (homme)',
        translationEn: 'Brother / Cousin (male)',
        illustration: '👦',
        audio: 'Li-ndeko_mobali',
        explanation: 'Terme pouvant désigner un frère ou un cousin masculin',
        explanationEn: 'Term that can refer to a brother or a male cousin',
        example: 'Ndeko mobali azali na école. (Mon frère est à l\'école.)',
        exampleEn: 'Ndeko mobali azali na école. (My brother is at school.)'
    },
    'Ndeko mwasi (Sœur / Cousine)': {
        translation: 'Sœur / Cousine (femme)',
        translationEn: 'Sister / Cousin (female)',
        illustration: '👧',
        audio: 'Li-ndeko_mwasi',
        explanation: 'Terme pouvant désigner une sœur ou une cousine féminine',
        explanationEn: 'Term that can refer to a sister or a female cousin',
        example: 'Ndeko mwasi azali koya. (Ma sœur vient.)',
        exampleEn: 'Ndeko mwasi azali koya. (My sister is coming.)'
    },
    'Mwana (Enfant)': {
        translation: 'Enfant',
        translationEn: 'Child',
        illustration: '👶',
        audio: 'Li-mwana',
        explanation: 'Terme général pour désigner un enfant',
        explanationEn: 'General term for a child',
        example: 'Mwana azali koyekola. (L\'enfant apprend.)',
        exampleEn: 'Mwana azali koyekola. (The child is learning.)'
    },
    'Bana (Enfants)': {
        translation: 'Enfants',
        translationEn: 'Children',
        illustration: '👶',
        audio: 'Li-bana',
        explanation: 'Pluriel de Mwana (Enfant)',
        explanationEn: 'Plural of Mwana (Child)',
        example: 'Bana bazali kosala. (Les enfants travaillent.)',
        exampleEn: 'Bana bazali kosala. (The children are working.)'
    },

    'Mwana ya liboso (Aîné)': {
        translation: 'L aîné',
        translationEn: 'The eldest',
        illustration: '👶',
        audio: 'Li-mwana_ya_liboso'

    },

      'Mwana ya suka (Cadet)': {
        translation: 'Cadet',
        translationEn: 'Youngest',
        illustration: '👶',
        audio: 'Li-mwana_ya_suka'

    },

      'Moboti (Géniteur)': {
        translation: 'Géniteur',
        translationEn: 'Biological parent',
        illustration: '👨',
        audio: 'Li-moboti',
        explanation: 'Personne qui a engendré un enfant (père biologique)',
        explanationEn: 'Person who fathered a child (biological father)'
    },
    'Baboti (Géniteurs)': {
        translation: 'Géniteurs',
        translationEn: 'Biological parents',
        illustration: '👨‍👩',
        audio: 'Li-baboti',
        explanation: 'Pluriel de Moboti (Géniteur) - les parents biologiques',
        explanationEn: 'Plural of Moboti (Biological parent) - the biological parents'
    },

     'Mukolo (Grand/Le plus âgé)': {
        translation: 'Grand/Le plus âgé',
        translationEn: 'Elder/The oldest',
        illustration: '👨‍🦳',
        audio: 'Li-mukolo',
        explanation: 'Terme pour désigner la personne la plus âgée',
        explanationEn: 'Term used for the oldest person',
        example: 'Mukolo azali na mayele. (L\'aîné a de la sagesse.)',
        exampleEn: 'Mukolo azali na mayele. (The elder has wisdom.)'
    },
    'Muke (Petit/Le moins âgé)': {
        translation: 'Petit/Le moins âgé',
        translationEn: 'Younger/The youngest',
        illustration: '👶',
        audio: 'Li-muke',
        explanation: 'Terme pour désigner la personne la plus jeune',
        explanationEn: 'Term used for the youngest person',
        example: 'Muke azali moke. (Le cadet est petit.)',
        exampleEn: 'Muke azali moke. (The youngest is small.)'
    },




    'Mwana mobali (Fils)': {
        translation: 'Fils',
        translationEn: 'Son',
        illustration: '👦',
        audio: 'Li-mwana_mobali',
        explanation: 'Enfant de sexe masculin',
        explanationEn: 'Male child',
        example: 'Mwana mobali azali kosala devoirs. (Le fils fait ses devoirs.)',
        exampleEn: 'Mwana mobali azali kosala devoirs. (The son is doing homework.)'
    },
    'Mwana mwasi (Fille)': {
        translation: 'Fille',
        translationEn: 'Daughter',
        illustration: '👧',
        audio: 'Li-mwana_mwasi',
        explanation: 'Enfant de sexe féminin',
        explanationEn: 'Female child',
        example: 'Mwana mwasi azali kolala. (La fille dort.)',
        exampleEn: 'Mwana mwasi azali kolala. (The daughter is sleeping.)'
    },

    // Grands-parents
    'Koko (Grand-parent)': {
        translation: 'Grand-parent',
        translationEn: 'Grandparent',
        illustration: '👴',
        audio: 'Li-koko',
        explanation: 'Terme général pour grand-parent (grand-mère ou grand-père)',
        explanationEn: 'General term for a grandparent (grandmother or grandfather)',
        example: 'Koko azali kotanga masolo. (Le grand-parent raconte des histoires.)',
        exampleEn: 'Koko azali kotanga masolo. (The grandparent tells stories.)'
    },
    'Koko ya mwasi (Grand-mère)': {
        translation: 'Grand-mère',
        translationEn: 'Grandmother',
        illustration: '👵',
        audio: 'Li-koko_ya_mwasi',
        explanation: 'Mère du père ou de la mère',
        explanationEn: 'Mother of the father or the mother',
        example: 'Koko ya mwasi azali koloba masolo ya kala. (Grand-mère raconte des histoires d\'autrefois.)',
        exampleEn: 'Koko ya mwasi azali koloba masolo ya kala. (Grandmother tells stories of the old days.)'
    },
    'Koko ya mobali (Grand-père)': {
        translation: 'Grand-père',
        translationEn: 'Grandfather',
        illustration: '👴',
        audio: 'Li-koko_ya_mobali',
        explanation: 'Père du père ou de la mère',
        explanationEn: 'Father of the father or the mother',
        example: 'Koko ya mobali azali na mayele mingi. (Grand-père a beaucoup de sagesse.)',
        exampleEn: 'Koko ya mobali azali na mayele mingi. (Grandfather has a lot of wisdom.)'
    },
    'Ba koko (Grands-parents / Ancêtres)': {
        translation: 'Grands-parents / Ancêtres',
        translationEn: 'Grandparents / Ancestors',
        illustration: '👴👵',
        audio: 'Li-ba_koko',
        explanation: 'Pluriel de Koko, désigne les grands-parents ou les ancêtres',
        explanationEn: 'Plural of Koko, refers to grandparents or ancestors',
        example: 'Ba koko bazali na mayele mingi. (Les grands-parents ont beaucoup de sagesse.)',
        exampleEn: 'Ba koko bazali na mayele mingi. (Grandparents have a lot of wisdom.)'
    },

    // Oncles et tantes
    'Mama Kulutu / Papa Kulutu (Oncle/Tante aîné(e))': {
        translation: 'Oncle/Tante (le/la plus âgé(e) de la famille)',
        translationEn: 'Uncle/Aunt (the eldest in the family)',
        illustration: '👨‍🦳👩‍🦳',
        explanation: 'Désigne le grand-frère ou la grande-sœur d\'un de nos parents. C\'est l\'équivalent de l\'oncle ou de la tante (le/la plus âgé(e)) de la famille en français',
        explanationEn: 'Refers to the older brother or older sister of one of our parents. This is the equivalent of the eldest uncle or aunt in the family',
        example: 'Mama Kulutu azali koya. (Ma tante aînée vient.)',
        exampleEn: 'Mama Kulutu azali koya. (My eldest aunt is coming.)'
    },
    'Mama Leki / Papa Leki (Oncle/Tante cadet(te))': {
        translation: 'Oncle/Tante (le/la plus jeune)',
        translationEn: 'Uncle/Aunt (the youngest)',
        illustration: '👨‍🦰👩‍🦰',
        explanation: 'Désigne le petit-frère ou la petite-sœur d\'un de nos parents. C\'est l\'équivalent de l\'oncle ou de la tante (le/la plus jeune) en français',
        explanationEn: 'Refers to the younger brother or younger sister of one of our parents. This is the equivalent of the youngest uncle or aunt',
        example: 'Papa Leki azali na université. (Mon oncle cadet est à l\'université.)',
        exampleEn: 'Papa Leki azali na université. (My youngest uncle is at university.)'
    },
    'Noko (Oncle maternel)': {
        translation: 'Oncle maternel',
        translationEn: 'Maternal uncle',
        illustration: '👨‍🦰',
        audio: 'Li-noko',
        explanation: 'Frère de la mère, souvent très respecté dans la culture congolaise',
        explanationEn: 'Brother of the mother, often held in great respect in Congolese culture',
        example: 'Noko azali koya na ndako. (L\'oncle maternel vient à la maison.)',
        exampleEn: 'Noko azali koya na ndako. (The maternal uncle is coming to the house.)'
    },
    'Tata monene (Oncle paternel)': {
        translation: 'Oncle paternel',
        translationEn: 'Paternal uncle',
        illustration: '👨‍🦳',
        audio: 'Li-tata_monene',
        explanation: 'Grand frère du père (forme respectueuse)',
        explanationEn: 'Older brother of the father (respectful form)',
        example: 'Tata monene azali na nzela. (L\'oncle paternel est en route.)',
        exampleEn: 'Tata monene azali na nzela. (The paternal uncle is on his way.)'
    },
    'Mama monene (Tante maternelle)': {
        translation: 'Tante maternelle',
        translationEn: 'Maternal aunt',
        illustration: '👩‍🦳',
        audio: 'Li-mama_monene',
        explanation: 'Grande sœur de la mère',
        explanationEn: 'Older sister of the mother',
        example: 'Mama monene azali kobimisa mwana. (La tante maternelle sort avec l\'enfant.)',
        exampleEn: 'Mama monene azali kobimisa mwana. (The maternal aunt is taking the child out.)'
    },

    // Belle-famille
    'Semeki (Beau-frère / Belle-sœur)': {
        translation: 'Beau-frère / Belle-sœur',
        translationEn: 'Brother-in-law / Sister-in-law',
        illustration: '👨‍💼👰',
        audio: 'Li-semeki',
        explanation: 'Terme général pour désigner un beau-frère ou une belle-sœur',
        explanationEn: 'General term for a brother-in-law or sister-in-law',
        example: 'Semeki azali malamu. (Mon beau-frère/ma belle-sœur est gentil(le).)',
        exampleEn: 'Semeki azali malamu. (My brother-in-law/sister-in-law is kind.)'
    },
    'Mama Bokilo / Papa Bokilo / Bokilo (Beau-père/Belle-mère/Belle-fille/Gendre)': {
        translation: 'Beau-père / Belle-mère / Belle-fille / Gendre',
        translationEn: 'Father-in-law / Mother-in-law / Daughter-in-law / Son-in-law',
        illustration: '👨‍👩‍👧',
        audio: 'Li-bokilo',
        explanation: 'Terme pour désigner les beaux-parents ou les beaux-enfants (gendre/belle-fille)',
        explanationEn: 'Term for in-law parents or in-law children (son-in-law/daughter-in-law)',
        example: 'Bokilo azali koya. (Mon beau-père/ma belle-mère/mon gendre/ma belle-fille vient.)',
        exampleEn: 'Bokilo azali koya. (My father-in-law/mother-in-law/son-in-law/daughter-in-law is coming.)'
    },

    // Neveux, nièces
    'Mwana ya ndeko mobali (Neveu)': {
        translation: 'Neveu',
        translationEn: 'Nephew',
        illustration: '👦',
        audio: 'Li-mwana_ya_ndeko_mobali',
        explanation: 'Fils du frère ou du cousin masculin',
        explanationEn: 'Son of the brother or the male cousin',
        example: 'Mwana ya ndeko mobali azali na kelasi. (Le neveu est à l\'école.)',
        exampleEn: 'Mwana ya ndeko mobali azali na kelasi. (The nephew is at school.)'
    },
    'Mwana ya ndeko mwasi (Nièce)': {
        translation: 'Nièce',
        translationEn: 'Niece',
        illustration: '👧',
        audio: 'Li-mwana_ya_ndeko_mwasi',
        explanation: 'Fille de la sœur ou de la cousine',
        explanationEn: 'Daughter of the sister or the cousin',
        example: 'Mwana ya ndeko mwasi azali kolia. (La nièce mange.)',
        exampleEn: 'Mwana ya ndeko mwasi azali kolia. (The niece is eating.)'
    },
    'Mobali ya ndeko mwasi (Beau-frère)': {
        translation: 'Beau-frère',
        translationEn: 'Brother-in-law',
        illustration: '👨‍💼',
        audio: 'Li-mobali_ya_ndeko_mwasi',
        explanation: 'Mari de la sœur',
        explanationEn: 'Husband of the sister',
        example: 'Mobali ya ndeko mwasi azali koloba. (Le beau-frère parle.)',
        exampleEn: 'Mobali ya ndeko mwasi azali koloba. (The brother-in-law is talking.)'
    },
    'Mwasi ya ndeko mobali (Belle-sœur)': {
        translation: 'Belle-sœur',
        translationEn: 'Sister-in-law',
        illustration: '👰',
        audio: 'Li-mwasi_ya_ndeko_mobali',
        explanation: 'Épouse du frère',
        explanationEn: 'Wife of the brother',
        example: 'Mwasi ya ndeko mobali azali kolamba. (La belle-sœur cuisine.)',
        exampleEn: 'Mwasi ya ndeko mobali azali kolamba. (The sister-in-law is cooking.)'
    },

    // Jumeaux
    'Lipasa (Jumeau / Jumelle)': {
        translation: 'Jumeau / Jumelle',
        translationEn: 'Twin (male/female)',
        illustration: '👶',
        audio: 'Li-lipasa',
        explanation: 'Terme pour désigner un jumeau ou une jumelle (singulier)',
        explanationEn: 'Term for a twin, male or female (singular)',
        example: 'Lipasa na ngai azali malamu. (Mon jumeau/ma jumelle est gentil(le).)',
        exampleEn: 'Lipasa na ngai azali malamu. (My twin is kind.)'
    },
    'Mapasa (Jumeaux / Jumelles)': {
        translation: 'Jumeaux / Jumelles',
        translationEn: 'Twins',
        illustration: '👶👶',
        audio: 'Li-mapasa',
        explanation: 'Terme pour désigner les jumeaux (pluriel)',
        explanationEn: 'Term for twins (plural)',
        example: 'Mapasa bazali kosala ensemble. (Les jumeaux font tout ensemble.)',
        exampleEn: 'Mapasa bazali kosala ensemble. (The twins do everything together.)'
    },

    // Princes (terme culturel)
    'Mobeko (Prince)': {
        translation: 'Prince',
        translationEn: 'Prince',
        illustration: '👑',
        audio: 'Li-mobeko',
        explanation: 'Dans la culture congolaise, la société s\'apparentait à une famille. L\'individualisme n\'existait pas. La société se concevait et évoluait en collectivité. C\'est la raison pour laquelle les termes "cousin", "cousine", "Monsieur" et "Madame" n\'existent pas en lingala, parce que nous étions tous frères et sœurs, tous parents, enfants de quelqu\'un dans l\'inconscient collectif',
        explanationEn: 'In Congolese culture, society was conceived as one large family. Individualism did not exist; society was built and lived collectively. This is why the terms "cousin," "Mister," and "Madam" do not exist in Lingala — in the collective mindset, everyone was a brother or sister, a relative, someone\'s child',
        example: 'Mobeko azali koya. (Le prince vient.)',
        exampleEn: 'Mobeko azali koya. (The prince is coming.)'
    },
    'Mibeko (Princes)': {
        translation: 'Princes',
        translationEn: 'Princes',
        illustration: '👑',
        audio: 'Li-mibeko',
        explanation: 'Pluriel de Mobeko (Prince)',
        explanationEn: 'Plural of Mobeko (Prince)',
        example: 'Mibeko bazali koya. (Les princes viennent.)',
        exampleEn: 'Mibeko bazali koya. (The princes are coming.)'
    },

    // Famille et relations
    'Libota (Famille)': {
        translation: 'Famille',
        translationEn: 'Family',
        illustration: '👨‍👩‍👧‍👦',
        audio: 'Li-libota',
        explanation: 'La famille entière, y compris les parents proches et éloignés',
        explanationEn: 'The whole family, including close and extended relatives',
        example: 'Libota na ngai ezali monene. (Ma famille est grande.)',
        exampleEn: 'Libota na ngai ezali monene. (My family is big.)'
    },
    'Mabota (Familles)': {
        translation: 'Familles',
        translationEn: 'Families',
        illustration: '👨‍👩‍👧‍👦',
        audio: 'Li-mabota',
        explanation: 'Pluriel de Libota (Famille)',
        explanationEn: 'Plural of Libota (Family)',
        example: 'Mabota na Congo ezali minene. (Les familles au Congo sont grandes.)',
        exampleEn: 'Mabota na Congo ezali minene. (Families in Congo are big.)'
    },

    'Moninga (Ami)': {
        translation: 'Ami',
        translationEn: 'Friend',
        illustration: '👥',
        audio: 'Li-moninga',
        explanation: 'Personne avec qui on a une relation d\'amitié',
        explanationEn: 'Person with whom one shares a friendship',
        example: 'Moninga na ngai azali malamu. (Mon ami est gentil.)',
        exampleEn: 'Moninga na ngai azali malamu. (My friend is kind.)'
    },
    'Mobali (Homme)': {
        translation: 'Mari / Époux / Homme',
        translationEn: 'Husband / Spouse / Man',
        illustration: '👨‍💼',
        audio: 'Li-mobali',
        explanation: 'Époux, homme marié ou homme en général',
        explanationEn: 'Husband, married man, or man in general',
        example: 'Mobali na ngai azali malamu. (Mon mari est gentil.)',
        exampleEn: 'Mobali na ngai azali malamu. (My husband is kind.)'
    },
    'Mibali (Hommes)': {
        translation: 'Hommes / Maris',
        translationEn: 'Men / Husbands',
        illustration: '👨‍💼',
        audio: 'Li-mibali',
        explanation: 'Pluriel de Mobali (Homme)',
        explanationEn: 'Plural of Mobali (Man)',
        example: 'Mibali bazali kosala. (Les hommes travaillent.)',
        exampleEn: 'Mibali bazali kosala. (The men are working.)'
    },
    'Mwasi (Femme)': {
        translation: 'Épouse / Femme mariée / Femme',
        translationEn: 'Wife / Married woman / Woman',
        illustration: '👰',
        explanation: 'Femme mariée, conjointe ou femme en général',
        explanationEn: 'Married woman, spouse, or woman in general',
        example: 'Mwasi na ngai azali kitoko. (Ma femme est belle.)',
        exampleEn: 'Mwasi na ngai azali kitoko. (My wife is beautiful.)'
    },
    'Basi (Femmes)': {
        translation: 'Femmes / Épouses',
        translationEn: 'Women / Wives',
        illustration: '👰',
        explanation: 'Pluriel de Mwasi (Femme)',
        explanationEn: 'Plural of Mwasi (Woman)',
        example: 'Basi bazali koloba. (Les femmes parlent.)',
        exampleEn: 'Basi bazali koloba. (The women are talking.)'
    },
};

export default famille;
